import React from 'react';
import classNames from 'classnames';
import Typography from '@lib/components/Typography/Typography';
import styles from './TableCounter.module.scss';

export interface TableCounterProps {
  totalEntries: number;
  counterText: string;
  className?: string;
}

function TableCounter({
  totalEntries,
  counterText,
  className,
}: TableCounterProps) {
  return (
    <Typography
      variant="caption"
      className={classNames(styles.counter, className)}
      data-test-id="table__counter"
    >
      {totalEntries} {counterText}
    </Typography>
  );
}

export default TableCounter;
